export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 0_03.6538eed4.jpg";